<div
  class="relative flex p-1 rounded-xl border border-white/50 dark:border-white/[0.12] bg-white/60 dark:bg-white/[0.05] backdrop-blur-sm shadow-sm transition-all duration-200"
  [ngClass]="containerHeight()"
>
  <!-- Selection indicator (slides behind selected choice) -->
  <div
    class="absolute top-1 bottom-1 bg-white/90 dark:bg-white/[0.15] rounded-lg shadow-sm transition-all duration-300 ease-out pointer-events-none"
    [style.left]="indicatorLeft()"
    [style.width]="indicatorWidth()"
  ></div>

  <!-- Choice segments -->
  @for (option of options(); track option.value) {
  <button
    type="button"
    class="flex-1 relative z-10 flex items-center justify-center gap-2 transition-colors duration-300 cursor-pointer"
    [ngClass]="choiceButtonClasses()"
    [class.text-primary]="value() === option.value"
    [class.font-semibold]="value() === option.value"
    [class.text-slate-500]="value() !== option.value"
    [class.dark:text-slate-400]="value() !== option.value"
    (click)="select(option.value)"
  >
    @if (option.icon) { @if (isEmoji(option.icon)) {
    <span>{{ option.icon }}</span>
    } @else {
    <span class="material-symbols-outlined !text-[18px]"
      >{{ option.icon }}</span
    >
    } } {{ option.label }}
  </button>
  }
</div>
